import $ from 'jquery';

import {View} from 'backbone';
import {Model} from 'backbone';
import util             from 'util/Util.js';
import _Template from 'designer/layout-toolbar-pane.ejs';
import Immutable from 'immutable';
import listService      from 'ListService.js';
import eventBus         from 'EventBus.js';
import pageSyncService  from 'PageSyncService.js';
import geometryService  from 'GeometryService';
import constants from 'Constants.js';
import groupGenericTemplate from 'toolbox/toolbox-group.ejs';
import groupCommonTemplate from 'toolbox/toolbox-group-common.ejs';
import toolboxDesignerTemplate from 'report/toolbox/toolbox-groups.ejs';
import groupAssetemplate        from 'toolbox/toolbox-group-assets.ejs';
import toolboxTabsTemplate from 'report/toolbox/toolbox-tabs.ejs';
import formModel        from 'formModel.js';
import zoomService      from 'ZoomService.js';
import assetUI from 'AssetUI';
import AddAssetView             from 'common-views/AddAssetView.js';
import assetCollection          from 'AssetCollection.js';
import toolboxItemMapService from '../../service/ToolboxItemMapService.js';
import focusController  from 'FocusController.js';
import dragDropService   from 'DragDropService.js';
import CommonGroupConfigView from 'common-views/CommonGroupConfigView.js';
import AccountService from 'AccountService.js';
import AlertDialogView from 'common-views/AlertDialogView.js';
import mobileDesignConfirmationModal from 'designer/modals/MobileDesignConfirmationModal.js';
import mobileDesignInformationModal from 'designer/modals/MobileDesignInformationModal.js';
import undoService from 'UndoService.js';
import factoryService from 'FactoryService.js';
import crudController           from 'CrudController.js';
import textConstants            from 'TextConstants';
import restService from 'RestService';
import leftPanelState   from "LeftPanelStateService";

import ConfirmDialogView from 'common-views/ConfirmDialogView';
import groupController from "../../controllers/GroupController";
import groupService from '../../service/GroupService.js';

class ReportToolbarPaneView extends View {

    initialize(opts) {
        this.defaultGroup = constants.DEFAULT_TOOLBOX_GROUP;
        this.options = opts || {};
        this.template = _Template;
        this.tagName = 'div';
        this.id = opts.el;


        this.events = {
            //'click #desktopLayout, #tabletLayout, #phoneLayout' : 'changeLayout',
            'click #behaviorView,#workflowView':'handleLinkNavigation',
            'click #group,#unGroup': 'groupingUngrouping',
            'click .layout-switch' : 'handleChangeLayout',
            'click .control-tabs li a' : 'changeTabs', 
            'click #zoom-in': 'zoomIn',
            'click #zoom-out': 'zoomOut',
            'click #actual-size': 'actualSize',
            'click #common_config': 'commonConfig',
            'drop #toolSearch': 'avoidDragAndDrop',
            'click #undoAction': 'undoAction',
            'click #redoAction': 'redoAction',
            'click #deleteItem': 'deleteItem',
            'click #behaviors': 'behaviors',
            'click .asset': 'assetClicked',
            'click .asset_new': 'addAsset',
            'click .asset_delete': 'deleteAsset',
            'dblclick .asset p': 'showFieldAssetName', 
            'keyup .edit-asset-name': 'changeAssetName', 
            'focusout .edit-asset-name': 'changeAssetName'
            // TODO remove after reports desktop regains a menubar
            // 'click #saveReport': 'saveReport'
        };

        this.templateMap = Immutable.Map([
            ['all', groupGenericTemplate],
            ['buttons', groupGenericTemplate],
            ['layout', groupGenericTemplate],
            ['input', groupGenericTemplate],
            ['reporting', groupGenericTemplate],
            ['containers', groupGenericTemplate],
            ['assets', groupAssetemplate],
            ['common', groupCommonTemplate]
        ]);

        this.selectedGroupElement = this.defaultGroup;
        this.toolboxItems = toolboxItemMapService.getReportItemsByGroup('all');
        this.model.set('helpUrl', constants.HELP_REPORT_URL);
        this.model.set('helpUrl2', constants.HELP_REPORT_TOOLBAR_URL);

        this.listenTo(eventBus, 'assetAdded', this.showAssets);
        this.listenTo( eventBus, 'commonGroupUpdated', this.commonGroupUpdated );

        if (!util.hasEventListener(eventBus._events, 'drawToolBarOnResizeWindow')) {
            this.listenTo(eventBus, 'drawToolBarOnResizeWindow', this.setSelectedGroup);
        }

        return this;
    }

    behaviors(ev){
        ev.preventDefault();
        leftPanelState.save();
        Backbone.history.loadUrl('behaviors');
    }

    assetClicked(ev) {
        if (ev.type === "click") {
            assetUI.assetClicked(ev, this);
        }
    }

    showFieldAssetName(ev) {
        assetUI.showFieldAssetName(ev);
    }

    changeAssetName(ev) { 
        assetUI.changeAssetName(ev);
    }

    showAssets() { 
        assetUI.showAssets(); 
        assetUI.attachRightClickMenu(this);
        this.delegateEvents();
    }

    groupingUngrouping() {
        groupController.toggleGroup(listService.selected);
    }

    deleteAsset() {
        if (!listService.selectedAsset) { 
            return;
        }

        assetUI.deleteAsset(this);
    }

    execDeleteAsset() {
        const
                confirmText = 'Are you sure you want to delete this asset?',
                confirmTitle = 'Delete Asset',
                confirmSuccess = ()=> {
                    restService.deleteAsset(listService.selectedAsset.id, this.deleteAssetCallback);

                    assetCollection.remove(listService.selectedAsset.id);
                    listService.clearSelected();
                    this.showAssets();/*
                    $('#common-carousel div').removeClass('active'); 
                    $('#common-carousel div:first-child').addClass('active');*/
                },
                confirmView = new ConfirmDialogView({
                    model: new Model({
                        text: confirmText,
                        success: confirmSuccess,
                        title: confirmTitle,
                        height: 125, with: 400
                    })
                });

            confirmView.render();
    }

    deleteItem() {
        //TODO - Determine if we are deleting an Asset or Control.
        if (listService.selected.size > 0) {
            console.log('delete control');
            crudController.deleteSelected();
        } else if (listService.selectedAsset) {

            this.deleteAsset();
        } else if (listService.mainKind === constants.KIND_REPORT) {
            // PF-4059 If in report view (we are, or we shouldn't be here?), delegate to main menu Edit delete to delete, say, the current page
            $('#designerDelete').click();
        }
    }

    handleLinkNavigation(){
        listService.itemSearched = 0;
        listService.linkClicked = true;
    }

    avoidDragAndDrop(){
        return false;
    }

    commonGroupUpdated() {
        this.setSelectedGroup('common');
    }

    /*
    // TODO re-factor elsewhere when menubar returns to report desktop
    saveReport() {
        //alert('TODO Save reports');
        // formSaveService.saveCurrentReportAsNew().then( data => {
        //     notificationService.success( data );
        // });

        formSaveService.saveCurrentReport( { isNewVersion: false } ).then( data => {
            notificationService.success( data );
        });

        // formSaveService.saveCurrentReport( { isNewVersion: true} ).then( data => {
        //     notificationService.success( data );
        // });
    }
    */

    commonConfig(ev) {
        const view = new CommonGroupConfigView({model: this.model});
        view.render();
    }

    addAsset(ev) {
        constants.maxItemOnSlide = assetUI.calculateItemsPerSlide(this.selectedGroupElement);
        assetUI.showLabelAssetName();
        const view = new AddAssetView({model: this.model});
        view.render();
    }

    handleChangeLayout(ev) {
        ev.preventDefault();
        leftPanelState.save();
        const target = ev.currentTarget;
        const layoutType = target.getAttribute('data-layout');
        const currentForm = listService.currentForm;
        listService.linkClicked = true;

        if (layoutType === 'deviceDesktop') {
            // No Access Needed for Desktop Layout
            this.changeLayout(target, layoutType, currentForm);
        } else {

            AccountService.verifyResponsive().then((hasResponsive) => {

                if (hasResponsive) {
                    if (currentForm.model.has('responsive') && util.isTrue(currentForm.model.get('responsive'))) {
                        this.changeLayout(target, layoutType, currentForm);
                    } else {

                        var confirmationModal = new mobileDesignConfirmationModal({model: new Model()});
                        confirmationModal.render().then((result)=>{

                            var informationModal = new mobileDesignInformationModal({model: new Model()});
                            informationModal.render().then((result)=>{
                                this.changeLayout(target, layoutType, currentForm);
                                return('OK');
                            }).catch((error) => {
                                var msg = error || 'Unknown Error';
                                console.log('Mobile information modal: ', msg)
                                return(error);
                            });
                            return('OK');
                        }).catch((error) => {
                            var msg = error || 'Unknown Error';
                            console.log('Mobile confirmation modal: ', msg)
                            return(error);
                        });
                    }
                } else {
                    const
                        alertText = constants.MSG_RESPONSIVE_DENIED,
                        alertTitle = constants.TITLE_ENABLE_RESPONSIVE,
                        alertVIew = new AlertDialogView({model: new Model({text: alertText, title: alertTitle})});

                    alertVIew.render();
                }
            });
        }
    }

    deleteAssetCallback(result) {
        eventBus.trigger('assetDeletedEvent', 'ASSET', result.assetId);
    }

    changeLayout(target, layoutType, currentForm){
        leftPanelState.save();
        formModel.set({
            currentDevice: layoutType
        })

        if(layoutType === 'deviceTablet' || layoutType === 'devicePhone'){
            currentForm.model.set('responsive', true);
        }

        this.cleanUpLayoutSwitches();
        this.drawLayout(layoutType);
        $(target).addClass('active');

        eventBus.trigger('selectForm');
    }

    cleanUpLayoutSwitches(){
        const layoutSwitches = this.$el.find('.layout-switch');
        layoutSwitches.map((index, item) => { $(item).removeClass('active') })
    }

    drawLayout(layoutType) {
        // Getting the current width either the one by default or the one assigned by the user via properties.
        //let currentWidth=listService.currentForm.model.attributes.formWidth;
        //let currentHeight=listService.currentForm.model.attributes.formHeight;

        let currentWidth = listService.currentForm.model.get('formWidth');
        let currentHeight = listService.currentForm.model.get('formHeight');



        const mapSizes = Immutable.Map([
            ['deviceDesktop', {width:currentWidth , height: currentHeight}],
            ['deviceTablet', {width: constants.TABLET_MAX_WIDTH, height: constants.TABLET_MAX_HEIGHT}],
            ['devicePhone', {width: constants.PHONE_MAX_WIDTH, height: constants.PHONE_MAX_HEIGHT}]
        ]);

        var newSize = mapSizes.get(layoutType);
        var newHeight = newSize.height;
        var newWidth = newSize.width;

        listService.currentForm.model.attributes.formHeight = newHeight;
        listService.currentForm.model.attributes.formWidth = newWidth;

        // Saving the current layout type inside the current model of the form.
        // This is perfomed to validate the bounda of the control in the PageSyncService.
        //listService.currentForm.model.attributes.currentLayout = layoutType;
        eventBus.trigger('formWidthSet', newWidth);
        eventBus.trigger('formHeightSet', newHeight);
        var currPage = listService.currentPageId;
        listService.currentPageId = 0;
        pageSyncService.displayPage(currPage);

        listService.currentForm.model.trigger('change');
    }

    zoomIn(evt) {
        evt.preventDefault();
        zoomService.handleCanvasZoom(constants.SCALE_FACTOR_ZOOM_IN);
        let canZoom=zoomService.handleAllControlsZoom(constants.SCALE_FACTOR_ZOOM_IN);
        if(canZoom){
            zoomService.fillZoomScaleAttribute(constants.SCALE_FACTOR_ZOOM_IN);
        }

    }

    zoomOut(evt) {
        evt.preventDefault();

        let canZoom=zoomService.handleAllControlsZoom(constants.SCALE_FACTOR_ZOOM_OUT);
        if(canZoom){
            zoomService.fillZoomScaleAttribute(constants.SCALE_FACTOR_ZOOM_OUT);
        }
        zoomService.handleCanvasZoom(constants.SCALE_FACTOR_ZOOM_OUT);
    }

    actualSize(evt) {
        evt.preventDefault();
        listService.currentForm.model.attributes.zoomScale=undefined;
        const layoutType = listService.currentForm.model.attributes.currentLayout;
        this.drawLayout(layoutType);
    }

    changeTabs(ev) {
        ev.preventDefault();
        const buttonName = ev.currentTarget.id;
        const tabSectionName = ev.currentTarget.name;

        this.setSelectedGroup(tabSectionName);

    }

    setSelectedGroup(sectionName, execContext = this) {
        constants.maxItemOnSlide = assetUI.calculateItemsPerSlide(sectionName);
        let context = execContext;
        context.selectedGroupElement = sectionName;

        var items = toolboxItemMapService.getReportItemsByGroup(sectionName);

        if (sectionName === 'common' && items.length) {
            let layoutItems = toolboxItemMapService.getReportItemsByGroup('all');
           
            items.forEach(i => {
                let control = layoutItems.find(c => c.factoryKey === i.factoryKey);
                if (control)  {
                    if (control.style) {
                        i.style = control.style;
                    }

                    if (control.textStyle) {
                        i.textStyle = control.textStyle;
                    }
                }
            });
        }
        
        context.model.set('items', items, {silent: true});

        // reset all tab panes
        $('#factories .tab-pane').empty();

        // insert template for selected group
        var gTemplate = context.templateMap.get(sectionName);
        $('#' + sectionName).html(gTemplate(context.model.toJSON()));

        if ((items.length + 1) < constants.MAX_ITEMS_PER_SECTION_TOOLBAR){
            $(".left.carousel-control").addClass("disable_a_href");
            $(".right.carousel-control").addClass("disable_a_href");
        }

        if (sectionName === 'assets') { 
            context.showAssets();
        }
    }

    createControl(factoryKey,position) {

      const factoryParams = factoryService.factories[factoryKey];

      let dropPos = {
        top: position.top,
        left: position.left
      };

      // The factory knows to create properties for the model
      const isGroup = constants.GROUPS_CONTROLS_KEYS.includes(factoryKey);
      this.control = !isGroup ? factoryParams.factory.createView(factoryKey, dropPos) : groupService.createNewGroup(factoryKey, dropPos);      

      this.control.validateToStayInBounds(this.control.model, true);
      if (this.control.model.get('invalid') === false) {
          dropPos = dragDropService.modifyControlOnEdgeDrop(dropPos, {
              width: util.extractNum(this.control.model.get('width')),
              height: util.extractNum(this.control.model.get('height'))
          });

          this.control.model.attributes.top = dropPos.top;
          this.control.model.attributes.left = dropPos.left;
          let grpVw = null;
          const dropGrpRect = {
              top: position.top,
              left: position.left,
              width: 1,
              height: 1,
              id: this.control.model.get('id')
          };
          // The control should be added to a group
          grpVw = dragDropService.droppedOnGroupObject(dropGrpRect);
          if (grpVw) {
              groupService.addControlToGroup(grpVw, this.control, dropPos);
          }

          listService.addObject(this.control.id, this.control);
         
        this.control.render();

        // Check if zoom
        if (listService.currentForm.model.attributes.zoomScale) {
          zoomService.handleSpecificControlZoom(listService.currentForm.model.attributes.zoomScale, this.control.id);
          // Placing the real position where the control is placed when its dropped inside the canvas and it is on zoomed mode.
          this.control.model.attributes.top = this.control.model.attributes.top / listService.currentForm.model.attributes.zoomScale;
          this.control.model.attributes.left = this.control.model.attributes.left / listService.currentForm.model.attributes.zoomScale;
        }


        // Mark the control -- only happens at creation drop. Subsequent focus change un-marks the control
        //focusController.markControl(control.id, true);
        listService.currentId = this.control.model.get('id');

        // Paint the properties
        //focusController.switchPropsViews();
        $('#' + listService.currentId + ' div.pf-control-core').trigger('click');
        $('#' + listService.currentId).trigger('focus');

        window.setTimeout(() => {
          $(constants.ID_SEL + this.control.id).trigger(constants.EV_CLICK + focusController.namespace);
            util.updateHelpDocumentationLink(this.control.model.get('factoryKey'));
        }, 0);
      } else {
        console.log('element out of boundaries');
      }
      // Note: listenForInstanceDragStart() called by pageView
      dragDropService.listenForDrop(constants.ID_SEL + this.control.id);
    }

    render() {
        let self = this;
        this.$el.empty();
        if (this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }
       
        $('#workflowView').remove();

        $('#toolbox-tabs').html(toolboxTabsTemplate);
        $('#factories').html(toolboxDesignerTemplate);

        constants.maxItemOnSlide = assetUI.calculateItemsPerSlide(this.selectedGroupElement);

        this.setSelectedGroup(this.selectedGroupElement);
        let selected = false;
        let initialEdges = {};

        if (listService.mainKind === 'R' && !listService.resizeWhenTooling) { 
            listService.resizeWhenTooling = true;
            $(window).on('resize', (e) => {
                if (self.selectedGroupElement === 'assets') {
                    let maxItems = assetUI.calculateItemsPerSlide(self.selectedGroupElement);
                    if (maxItems !== constants.maxItemOnSlide) {
                        constants.maxItemOnSlide = maxItems;
                        eventBus.trigger('drawToolBarOnResizeWindow', self.selectedGroupElement, self);
                    } 
                }
            }); 
        }        
        
        $(".layout-switch[data-layout='deviceTablet']").prop('disabled', 'disabled');
        $(".layout-switch[data-layout='devicePhone']").prop('disabled', 'disabled');
        
        dragDropService.initSearchToolBoxDraggable(selected, initialEdges, this.toolboxItems);

        this.delegateEvents();
        return this;
    }

    undoAction(){
        undoService.undo();
        eventBus.trigger('undoCacheEvent');
    }

    redoAction(){
        undoService.redo();
        eventBus.trigger('undoCacheEvent');
    }

    remove(){
         $('#toolSearch').unbind('typeahead:selected');
         super.remove();
    }
}

export default ReportToolbarPaneView;
